import { ComplianceCardData } from 'src/components/Compliance';
import Image1 from '../../assets/images/ComplianceWelcome1-v2.webp';
import Image2 from '../../assets/images/ComplianceWelcome2-v2.webp';

export const cardsData: ComplianceCardData[] = [
  {
    key: '1',
    title: 'I need to purchase renters insurance',
    mainText: (
      <>
        <p>
          TheGuarantors provides renters insurance that’s guaranteed to meet your building’s requirements. Your policy will include:
        </p>
        <ul>
          <li>Personal property</li>
          <li>Personal liability</li>
          <li>Additional coverages optional</li>
        </ul>
      </>
    ),
    img: Image1,
    linkText: 'Purchase coverage',
    bgColor: 'primary',
  },
  {
    key: '2',
    title: 'I already have renters insurance',
    mainText: (
      <>
        <p>
          Link your renters insurance policy and we’ll check to see if it meets your building’s requirements.
        </p>
      </>
    ),
    img: Image2,
    linkText: 'Verify my Policy',
    bgColor: 'secondary',
  },
];
